import React from 'react';
import { Section } from './ui/Section';
export function Bonuses() {
  const bonuses = [{
    number: '01',
    icon: '✅',
    title: 'Checklist de Clase de Emergencia',
    desc: 'Prepara cualquier clase en menos de 5 minutos. Sin improvisar. Sin estrés.',
    value: '7€'
  }, {
    number: '02',
    icon: '🎵',
    title: 'Guía de Selección Musical PRO',
    desc: 'Listas de reproducción organizadas por nivel, tempo y estilo. Nunca más fallarás con la música.',
    value: '9€'
  }, {
    number: '03',
    icon: '📊',
    title: 'Fichas de Seguimiento y Progreso',
    desc: 'Sistema de semáforo para detectar alumnos en riesgo de baja antes de que se vayan.',
    value: '7€'
  }, {
    number: '04',
    icon: '📅',
    title: 'Syllabus de 12 Semanas',
    desc: 'El plan exacto de qué enseñar cada clase durante un trimestre completo. Listo para usar mañana.',
    value: '12€'
  }, {
    number: '05',
    icon: '📱',
    title: 'Plantillas de Marketing y Copy',
    desc: '30 textos listos para publicar en Instagram y Facebook. Copies de captación, conexión y conversión.',
    value: '7€'
  }, {
    number: '06',
    icon: '📖',
    title: 'Diccionario de Terminología PRO',
    desc: 'El vocabulario técnico completo para hablar con autoridad y hacer que tus alumnos se sientan parte de algo profesional.',
    value: '5€'
  }];
  return <Section variant="alt" data-id="element-35">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-3 text-brand-title" data-id="element-36">
        🔥 6 Bonos Exclusivos Incluidos
      </h2>
      <p className="text-center text-brand-subtitle font-semibold mb-8 font-heading" data-id="element-37">
        Valor combinado: 47€ — GRATIS HOY
      </p>

      <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-38">
        ← Scroll to see full table →
      </div>

      <div className="overflow-x-auto mb-6" data-id="element-39">
        <table className="w-full min-w-[700px] border-collapse bg-white rounded-2xl overflow-hidden shadow-card border border-brand-border" data-id="element-40">
          <thead data-id="element-41">
            <tr className="bg-brand-bgAlt border-b border-brand-border" data-id="element-42">
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-43">
                #
              </th>
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-44">
                Bono
              </th>
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-45">
                Descripción
              </th>
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-46">
                Valor
              </th>
            </tr>
          </thead>
          <tbody data-id="element-47">
            {bonuses.map((bonus, i) => <tr key={i} className="hover:bg-brand-bgAlt transition-colors border-b border-brand-border last:border-0" data-id="element-48">
                <td className="p-3 text-brand-accent font-heading font-bold" data-id="element-49">
                  {bonus.number}
                </td>
                <td className="p-3" data-id="element-50">
                  <div className="flex items-center gap-3" data-id="element-51">
                    <span className="text-2xl" data-id="element-52">{bonus.icon}</span>
                    <span className="font-heading font-bold text-brand-subtitle text-sm" data-id="element-53">
                      {bonus.title}
                    </span>
                  </div>
                </td>
                <td className="p-3 text-brand-text font-body text-sm" data-id="element-54">
                  {bonus.desc}
                </td>
                <td className="p-3 text-brand-title font-heading font-bold" data-id="element-55">
                  {bonus.value}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <p className="text-center text-brand-text font-body text-sm" data-id="element-56">
        🎁 Los 6 bonos se desbloquean automáticamente al comprar hoy. Sin pasos
        extra, sin códigos. Llegan a tu correo junto al Manual PRO.
      </p>
    </Section>;
}